<template>
    <div class="box" :class="opts?'active':''" v-clickoutside="closeSelect">
        <p class="date-range" @click="opts=!opts" :class="opts ? 'active' : ''">{{ selected }}</p>
        <div class="date-range-opts" v-if="opts">
            <p v-for="(dates, key) in range" :key="key" @click="selectDateRange(dates.value)">{{ dates.name }}</p>
        </div>
    </div>    
</template>

<script>
import moment from 'moment';
import ChevronDown from "@/assets/icons/chevron-down.svg"
import ChevronUp from "@/assets/icons/chevron-up.svg"

export default {
    name: 'DateRangeFilter',
    components: {
        ChevronDown,
        ChevronUp
    },
    data: function(){
        return {
            opts: false,
            range: [{
                "name": "Hoy",
                "value": "4"
            },{
                "name": "Últimos 7 días",
                "value": "1"
            },{
                "name": "Últimos 15 días",
                "value": "2"
            },{
                "name": "Últimos 30 días",
                "value": "3"
            }],
            selected: "Últimos 7 días",
            today: moment().format("YYYY-MM-DD"),
        }
    },
    methods: {
        selectDateRange: function(value){
            this.opts = false
            this.$store.dispatch("auth/changeMaxRange", false)
            this.initRange = value
            let dateSelected = this.range.filter( data => {
                return data.value == value
            })
            this.selected = dateSelected[0].name;
            let initDate = this.today
            let endPrevious = initDate
            let initPrevious = moment().subtract(1,'d').format('YYYY-MM-DD')
            if (value == 1 ) {
                initDate = moment().subtract(7,'d').format('YYYY-MM-DD');
                initPrevious = moment().subtract(12,'d').format('YYYY-MM-DD');
                endPrevious = initDate
                
            } else if (value == 2) {
                initDate = moment().subtract(15,'d').format('YYYY-MM-DD');
                initPrevious = moment().subtract(28,'d').format('YYYY-MM-DD');
                endPrevious = initDate
            } else if (value == 3) {
                initDate = moment().subtract(30,'d').format('YYYY-MM-DD');
                initPrevious = moment().subtract(58,'d').format('YYYY-MM-DD');
                endPrevious = initDate
                this.$store.dispatch("auth/changeMaxRange", true)
            } else {
                initDate = this.today;
                initPrevious = moment().subtract(1,'d').format('YYYY-MM-DD');
                endPrevious = initPrevious;
            }
            
            this.$emit('selectedRange', [initDate, initPrevious, endPrevious, value]);
        },
        closeSelect: function(){
            if (this.opts){
                this.opts = false;
            }
        }
    },
    directives: {
        clickoutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
            stopProp(event) { event.stopPropagation() }
        }
    }
}
</script>

<style lang="sass" scoped>
.date-range
    width: 182px
    height: 32px
    border-radius: 4px
    border: solid 1px #ffffff
    padding-left: 8px
    line-height: 32px
    background: transparent
    font-family: Muli
    font-size: 16px
    font-weight: 500
    color: $light-grey
    appearance: none
    margin-bottom: 0
    float: right
    cursor: pointer
    @include mobile
        width: 100%
        padding-left: 8px
        box-sizing: border-box
.date-range:hover
    border: 1px solid $secondary-hover
.date-range.active
    background-color: #ffffff
    color: #999999
.date-range-opts
    position: absolute
    top: calc(100% + 4px)
    left: 0
    width: 100%
    background-color: #ffffff
    box-shadow: 0 0 4px 0 rgba(161,166,183,0.45)
    border-radius: 4px
    z-index: 999
.date-range-opts p 
    font-family: Muli
    font-size: 16px
    font-weight: 500
    color: #302f2f
    padding: 4px
    cursor: pointer
    position: relative
    @media (max-width: $tablet)
        padding: 10px 4px
.date-range-opts p:first-of-type
    border-top-left-radius: 4px
    border-top-right-radius: 4px
.date-range-opts p:last-of-type
    border-bottom-left-radius: 4px
    border-bottom-right-radius: 4px
.date-range-opts p:hover
    background-color: #0b99d8
    color: #ffffff
    @media (max-width: $tablet)
        background-color: #ffffff
        color: #302f2f
.date-range-opts p:hover::after
    @media (max-width: $tablet)
        content: ""
        position: absolute
        bottom: 0
        left: 0
        width: 90%
        margin: 0 5%
        height: 1px
        background-color: rgba($secondary, 0.2)
.box::after
    border-width: 1px
    border-style: solid
    border-color: transparent transparent #ffffff #ffffff
    height: 9px
    width: 9px
    display: block
    content: " "
    transform: rotate(-45deg)
    position: absolute
    top: 8px
    right: 8px
.box:hover::after
    border-color: transparent transparent $secondary-hover $secondary-hover
.box.active::after
    top: 14px
    transform: rotate(135deg)
</style>